/**
 * 경로별 SEO 기본 메타.
 * - 여기 없는 경로는 router 에서 noindex 로 처리된다 (로그인·회원가입·마이페이지·팝업·테스트 페이지 등).
 * - 상세 페이지(HFO_BI_002, HFO_PR_003, HFO_CS_002)는 데이터 로드 후 setPageMeta 로 제목·설명을 덮어쓴다.
 * - title 에는 사이트명이 자동으로 붙는다. 비우면 기본 제목을 쓴다.
 * - 핵심 키워드: 복지카드, 청구할인, 중복할인, 제휴 가맹점. KB국민카드 프라임+ 문구는 kbprm 전용 경로에만 쓴다.
 * - partnerDescription: 카드별 호스트(samsung, narasarang 등)에서 description 대신 쓰는 문구. 카드명이 맨 앞에 오도록 쓴다.
 *   {card} 는 siteProfiles 의 cardName, {intro} 는 카드 안내 문장(intro)으로 치환된다. 호스트별 경로(홈·브랜드·매장·쇼핑)에만 둔다.
 */
export const SEO_BY_PATH = {
	"/": {
		title: "",
		description:
			"복지카드 및 기업 패밀리카드로 제휴 가맹점에서 결제하면 최대 20% 청구할인. 추가 가입·연회비·전월 실적 없이 기존 할인과 중복 적용. 외식·쇼핑·호텔·키즈 등 200여 개 제휴 브랜드와 매장 안내.",
		partnerDescription: "{intro} 외식·쇼핑·호텔·키즈 등 제휴 브랜드와 매장 안내.",
	},
	"/HFO_BI_001": {
		title: "복지카드 제휴 브랜드 청구할인 혜택",
		description: "복지카드 및 기업 패밀리카드로 결제 시 청구할인되는 하이비타민 제휴 브랜드를 한눈에. 브랜드별 할인율(2%~20%)과 대상 카드, 외식·쇼핑·숙박·키즈·뷰티 카테고리별 안내.",
		partnerDescription: "{card}로 결제 시 청구할인되는 하이비타민 제휴 브랜드를 한눈에. 브랜드별 할인율과 외식·쇼핑·숙박·키즈·뷰티 카테고리별 안내.",
	},
	"/HFO_BI_001_KBPRM": {
		title: "KB국민카드 프라임+ 고객 전용 제휴가맹점 청구할인",
		canonicalOrigin: "https://kbprm.hivitamin.co.kr",
		description: "프라임+ 고객은 별도 응모 없이 제휴가맹점에서 KB국민카드로 결제 시 2~10% 청구할인. KB국민카드와 제휴된 (주)브릿지엠이 운영하는 Hi-비타민 서비스의 제휴 브랜드와 할인율 안내.",
	},
	"/HFO_BI_002": {
		title: "브랜드 복지카드 청구할인 혜택 및 매장 찾기",
		description: "제휴 브랜드의 복지카드 청구할인율, 대상 카드, 이용 안내와 가까운 매장 위치를 확인하세요.",
	},
	"/HFO_BI_002_KBPRM": {
		title: "KB국민카드 프라임+ 제휴 브랜드 할인 혜택 및 매장",
		canonicalOrigin: "https://kbprm.hivitamin.co.kr",
		description: "프라임+ 고객이 별도 응모 없이 KB국민카드로 결제 시 받는 제휴가맹점 청구할인 혜택과 매장 위치 안내.",
	},
	"/HFO_BI_003": {
		title: "제휴 문의",
		description: "복지카드 청구할인 가맹점으로 제휴를 원하는 기업과 브랜드를 위한 하이비타민 제휴 문의 안내.",
	},
	"/HFO_SP_001": {
		title: "온라인 쇼핑 복지카드 청구할인",
		description: "하이비타민 제휴 온라인 쇼핑몰에서 복지카드 및 기업 패밀리카드로 결제 시 적용되는 청구할인 혜택을 확인하세요.",
		partnerDescription: "{card} 온라인 쇼핑 청구할인. 하이비타민 제휴 온라인 쇼핑몰에서 {card}로 결제 시 적용되는 혜택을 확인하세요.",
	},
	"/HFO_CP_001": {
		title: "복지카드 청구할인 이용 방법",
		description: "가맹점 검색 → 복지카드 결제 → 익월 청구할인. 하이비타민 청구할인 서비스 이용 순서와 이용 전 확인 사항.",
	},
	"/HFO_MS_001": {
		title: "복지카드 제휴 매장 검색",
		description: "지역과 매장명으로 복지카드 청구할인이 되는 하이비타민 제휴 매장을 검색하고 위치를 확인하세요.",
		partnerDescription: "{card} 청구할인이 되는 하이비타민 제휴 매장을 지역과 매장명으로 검색하고 위치를 확인하세요.",
	},
	"/HFO_PR_001": {
		title: "프로모션 · 이벤트",
		description: "하이비타민에서 진행 중인 프로모션과 이벤트, 복지카드 제휴 브랜드 특별 혜택을 확인하세요.",
	},
	"/HFO_PR_003": {
		title: "이벤트 상세",
		description: "하이비타민 프로모션 이벤트 상세 안내.",
	},
	"/HFO_CS_001": {
		title: "공지사항",
		description: "하이비타민 서비스 공지사항과 신규 복지카드 제휴 브랜드 소식.",
	},
	"/HFO_CS_002": {
		title: "공지사항",
		description: "하이비타민 서비스 공지사항 상세.",
	},
	"/HFO_CS_003": {
		title: "자주하는 질문 - 복지카드 청구할인 중복 적용, 이용 방법",
		description: "복지카드 청구할인은 다른 할인과 중복되나요? 전월 실적 조건이 있나요? 하이비타민 청구할인 서비스 이용 방법, 할인 적용, 회원 관련 자주 묻는 질문과 답변.",
	},
	"/HFO_CS_004": {
		title: "1:1 문의",
		description: "하이비타민 서비스 이용 중 궁금한 점을 1:1 문의로 남겨 주세요.",
	},
	"/HFO_CO_003": {
		title: "개인정보처리방침",
		description: "하이비타민 개인정보처리방침.",
	},
	"/HFO_CO_004": {
		title: "이용약관",
		description: "하이비타민 서비스 이용약관.",
	},
	"/HFO_HI_001": {
		title: "서비스 소개 - 복지카드 청구할인",
		description: "제휴 가맹점에서 임직원 복지카드로 결제하면 최대 20% 청구할인. 전월 실적·횟수 제한 없음, 기존 할인과 중복 적용, 전국 쇼핑·문화·여행·외식 가맹점.",
	},
	"/HFO_HI_002": {
		title: "복지카드 청구할인 혜택 정리",
		description: "하이비타민 복지카드 청구할인 제휴 브랜드 수와 할인율(2~20%)을 업종별로 정리. 청구할인 적용 방식과 예외사항 안내.",
	},
	"/HFO_HI_004": {
		title: "기업 소개",
		description: "복지카드 청구할인 서비스 하이비타민을 운영하는 (주)브릿지엠 기업 소개.",
	},
};
